/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * @module Constants
 */
/**
 * @constant
 * A Default API endpoint version for a request
 */
export const GRAPH_API_VERSION = "v1.0";
/**
 * @constant
 * A Default base url for a request
 */
export const GRAPH_BASE_URL = "https://graph.microsoft.com/";
//# sourceMappingURL=Constants.js.map